import * as Yup from "yup";
const passwordRegex = /^(?=.*[0-9])(?=.*[!@#$%^&*])(?=.*[A-Z])/;
const resetPasswordValidationSchema = Yup.object({
  password: Yup.string()
    .min(8, "Password must be at least minimum of 8 characters")
    .matches(
      passwordRegex,
      "Password must contain at least one number, one special character, one uppercase letter, and be at least 8 characters long."
    )
    .required("Password is required"),
});

export { resetPasswordValidationSchema, passwordRegex };
